import { render, staticRenderFns } from "./EditableContact.vue?vue&type=template&id=2f49a7d6&scoped=true&"
import script from "./EditableContact.vue?vue&type=script&lang=js&"
export * from "./EditableContact.vue?vue&type=script&lang=js&"
import style0 from "./EditableContact.vue?vue&type=style&index=0&id=2f49a7d6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f49a7d6",
  null
  
)

export default component.exports